import { useEffect, useMemo, useState, useCallback } from 'react';

import { FiPlus } from 'react-icons/fi';
import { useHistory, useParams } from 'react-router-dom';
import { MoonLoader } from 'react-spinners';

import { useStudent } from '~/hooks/student';
import api from '~/services/api';

import BillingCard from './BillingCard';
import BillingProps from './interface';

import {
  AlertContainer,
  CardContainer,
  NewButton,
  NewButtonContainer,
  NewButtonLabel,
  Wrapper,
  NoDataFound,
} from './styles';

type RouteParams = {
  userId: string;
};

export function Billings() {
  const { push } = useHistory();
  const { userId: studentId } = useParams<RouteParams>();
  const { studentData } = useStudent();

  const [loading, setLoading] = useState(true);
  const [billings, setBillings] = useState<BillingProps[]>([]);

  useEffect(() => {
    async function fetchData() {
      const { data } = await api.get(
        `students/${studentData?.student?.id}/billings`,
      );

      setBillings(data);
    }

    fetchData();

    setLoading(false);
  }, [studentData]);

  const navigateToNewBilling = useCallback(() => {
    push(`/professional/students/${studentId}/billings/register`);
  }, [push, studentId]);

  const cardsMemo = useMemo(() => {
    return billings.length > 0 ? (
      <CardContainer>
        {billings.map((billing) => (
          <BillingCard key={billing.id} billing={billing} />
        ))}
      </CardContainer>
    ) : (
      <NoDataFound>
        <p>Nenhuma fatura cadastrada!</p>
      </NoDataFound>
    );
  }, [billings]);

  return (
    <>
      <NewButtonContainer>
        <NewButton onClick={navigateToNewBilling}>
          <FiPlus />
          <NewButtonLabel>nova fatura</NewButtonLabel>
        </NewButton>
      </NewButtonContainer>

      <Wrapper>
        {loading ? (
          <AlertContainer>
            <MoonLoader size={30} color="#FFDF22" />
          </AlertContainer>
        ) : (
          cardsMemo
        )}
      </Wrapper>
    </>
  );
}
